/*
 * @Description: 描述...
 * @Author: LiuYongChun
 * @Date: 2020-11-16 13:47:44
 * @LastEditors: LiuYongChun
 * @LastEditTime: 2020-11-20 10:27:31
 */
import Vue from 'vue';
import Spin from 'vue-plugin-spin';
import router from '@/router/index';
import tIcon from '@/components/Icon/index';
import tAction from '@/components/Action/index';
import tTable from '@/components/Table/index';
import tCard from '@/components/Card/index';
import tEditor from '@/components/Editor/index';
import uEditor from '@/components/Ueditor/index';
import Auth from '@/plugin/auth/index';
import Dialog from '@/plugin/dialog/index';
import Msg from '@/plugin/message/index';
import Log from '@/plugin/log/index';
import { vueError } from '@/plugin/log/log';
import App from './App.vue';
import store from './store/index';
import 'element-ui/lib/theme-chalk/index.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer)
Viewer.setDefaults({
  zIndexInline: 9999,
})
Vue.config.productionTip = false;
Vue.use(Spin);
Vue.use(tIcon);
Vue.use(tAction);
Vue.use(tTable);
Vue.use(tCard);
Vue.use(tEditor);
Vue.use(uEditor);
Vue.use(Dialog);
Vue.use(Msg);
Vue.use(Log);
Vue.use(Auth, { name: 'auth' });

Vue.config.errorHandler = (err, vm, info) => {
  vueError({
    title: err.name,
    desc: err.message,
    page: info,
  });
};

declare module 'vue/types/vue' {
  interface Vue {
    $log: Function,
    confirm: Function,
    alert: Function,
    msg: Function,
  }
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
